export class BookingDelayStatusConstant {
    static ON_TIME_ID = "ON_TIME";
    static NEAR_DEADLINE_ID = "NEAR_DEADLINE";
    static LATE_ID = "LATE";
  
    static OPTIONS = {
      [this.ON_TIME_ID]: {
        label: "Dans les délais",
        color: "green",
      },
      [this.NEAR_DEADLINE_ID]: {
        label: "Proche de l'échéance",
        color: "gold",
      },
      [this.LATE_ID]: {
        label: "En retard",
        color: "volcano",
      },
    };
  }

  export class BookingStateConstant {
    static PENDING_ID = "PENDING";
    static IN_PROGRESS_ID = "IN_PROGRESS";
    static CLOSED_ID = "CLOSED";
  
    static OPTIONS = {
      [this.PENDING_ID]: {
        label: "En attente",
        color: "blue",
      },
      [this.IN_PROGRESS_ID]: {
        label: "En cours",
        color: "cyan",
      },
      [this.CLOSED_ID]: {
        label: "Clôturé",
        color: "purple",
      },
    };
  }